import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../../MotivosRechazo/actions'
import { Field } from 'redux-form'
import { renderSelectField } from '../../fieldRenderers'
import { required } from '../../../Forms/fieldValidators'

function MotivosRechazo (props) {
  const { motivosRechazo, requestMotivosRechazo, tipo } = props

  useEffect(() => {
    requestMotivosRechazo(tipo)
  }, [requestMotivosRechazo, tipo])

  const onSelect = (motivoRechazo) => {
    if (motivoRechazo) {
      props.setMotivoRechazo(motivoRechazo.target.value)
    }
  }

  const renderMotivos = () => {
    const option = motivosRechazo && motivosRechazo.map(motivoRechazo => {
      return (
        <option
          value={motivoRechazo.nombreCorto}
          key={motivoRechazo.nombreCorto}
        >
          {motivoRechazo.nombre}
        </option>
      )
    })

    option.unshift((<option value={null} key={0} />))
    return option
  }

  return (
    <Field
      onChange={onSelect}
      name='motivoRechazo'
      label='Motivo de Rechazo'
      validate={required}
      component={renderSelectField}>
      { renderMotivos() }
    </Field>
  )
}

const mapStateToProps = (state) => ({
  motivosRechazo: state.motivosRechazo.motivosRechazo
})

const withRedux = connect(mapStateToProps, actions)

export default withRedux(MotivosRechazo)
